export default {
  all (state) {
    return state.all
  }
}
